module.exports = __webpack_public_path__ + "img/img-title-school.ffe45363.png";